import axios from "axios.js";
import { showSnackbar } from "./UiAction";

// Defines all states values
export const GET_STUDENT_COUNTS = "GET_STUDENT_COUNTS";
export const POST_GEOFENCE_TO_VEHICLE = "POST_GEOFENCE_TO_VEHICLE";
export const GET_SCHOOL_MARKER_DETAILS = "GET_SCHOOL_MARKER_DETAILS";
export const GET_ONLINE_OFFLINE_DRIVERS_COUNT = "GET_ONLINE_OFFLINE_DRIVERS_COUNT" 
export const GET_POSITIONS_DATE_WISE = "GET_POSITIONS_DATE_WISE" 
export const RESET_POSiTION_DATA = "RESET_POSiTION_DATA" 

export const getStudentsCounts = (driverId) => (dispatch) => { // get students counts api
  axios.get(`/driver/${driverId}/trip/started/details`).then((res) => {
    dispatch({
      type: GET_STUDENT_COUNTS,
      payload: res.data,
    });
  });
};

export const getSchoolMarkerDetails = () => (dispatch) => { 
  axios.get(`/schools/location`).then((res) => {
    dispatch({
      type: GET_SCHOOL_MARKER_DETAILS,
      payload: res.data,
    });
  });
};

export const getDriverCounts = () => (dispatch) => { 
  axios.get(`/drivers/online`).then((res) => {
    // console.log(res.data)
    dispatch({
      type: GET_ONLINE_OFFLINE_DRIVERS_COUNT,
      payload: res.data,
    });
  });
};

export const postGeofenceToVehicle = (data) => (dispatch) => { // post geofence to vehicle api
  axios.post('/vehicle/assign/geofence',data).then((res) => {
    dispatch(showSnackbar(res.data.message, 'top', "success"));
    dispatch({
      type: POST_GEOFENCE_TO_VEHICLE,
      payload: res.data,
    });
  })
  .catch((error) => {
    dispatch(showSnackbar(error.message, 'top', "error"));
  });
};

export const getPositionsDateWise = (from,to) => (dispatch) => { // post geofence to vehicle api
  axios.get(`/positions?from=${from}&to=${to}`).then((res) => {
    dispatch({
      type: GET_POSITIONS_DATE_WISE,
      payload: res.data,
    });
  })
  .catch((error) => {
    dispatch(showSnackbar(error.message, 'top', "error"));
  });
};

export const resetPositionData = () => ({
  type: RESET_POSiTION_DATA,
});